import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { Action, Space } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

const SPACE_CAN_SHARE_MODULE = [Action.SpaceWrite, Action.SpaceShareModule];

/**
 * Hook that returns list of space where a viewer can share a module to
 * User needs to have SpaceWrite or SpaceShareModule actions on a space to be able to share a module with it.
 * @returns {Space[]} List of allowed spaces
 */
const useAllowedSpaceToShareModule = (): Space[] => {
  const { viewer } = useTypedContext(AccountContext);
  const { spaces } = useTypedContext(SpacesContext);

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) =>
      hasAtLeastOneRequiredAction(SPACE_CAN_SHARE_MODULE, viewer, space.id)
    );
  }, [spaces, viewer]);

  return availableSpaces;
};

export default useAllowedSpaceToShareModule;
